import { whitelisted_paths, base_url } from '../utils/constants';

const getTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
  };
  

  const check_if_is_authenticated = async () => {
    let current_path = window.location.pathname
    let access_token = localStorage.getItem("access_token")
    if (!access_token && !whitelisted_paths.includes(current_path)) {
      console.log(window.location)
      window.location.href = "/login";
    } 

    if(access_token && (current_path == "/login" || current_path == "/signup")){
      window.location.href = "/accounts"
    }
  };

  const formatDate = (isoString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    };
  
    return new Date(isoString).toLocaleDateString('en-US', options);
  }


  export {
    getTimezone,
    check_if_is_authenticated,
    formatDate
  }